import React, { useState } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import records from "../../../Services/records";
import {
  Label,
  FormGroup,
  Collapse,
  Popover,
  Nav,
  NavLink,
  Col,
  Row,
  NavItem,
  Button,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
} from "reactstrap";
import bg4 from "../../../assets/utils/images/dropdown-header/abstract4.jpg";
let filterOptions = ["Property Temperature", "Lead Info", "Zip Code", "County"];
export default function FilterBy() {
  const history = useHistory();
  const location = useLocation()
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [temp, setTemp] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState({});
  const [keyword, setKeyword] = useState('');
  const [count, setCount] = useState(0);
  // const [filterValue, setFilterValue] = useState([])
  const [accordion, setAccordion] = useState([false, false, false, false]);

  const toggleAccordion = (tab) => {
    const state = accordion.map((x, index) => (tab === index ? !x : false));
    setAccordion(state);
  };

  const togglePopover = () => {
    setPopoverOpen(!popoverOpen);
  };

  // const removeFilterValue = (val) => {
  //     const newFilter = filterValue.filter((v) => v !== val)

  //     setFilterValue(newFilter)
  // }
  const add = (k, v) => {
    if (v !== "") {
      setData({ ...data, [k]: v });
    }
  };

  const del = (k) => {
    const newData = { ...data };
    delete newData[k];
    setData(newData);
  };

  const filter = () => {
    const queryString = Object.entries(data).filter(([key, value]) => value !== '')
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join("&");
            const searchParams = new URLSearchParams(location.search);
            if (searchParams.has('keyword')) {
              queryString = `keyword=${searchParams.get('keyword')}&${queryString}`;
            }
          
            const newUrl = `/records/?${queryString}`;
    history.push(`/records/?${queryString}`);
    setCount(Object.entries(data).filter(([key, value]) => value !== '').length)
    setPopoverOpen(!popoverOpen);
  };

  const reset = () => {
  const searchParams = new URLSearchParams(location.search);
  const keyword = searchParams.get('keyword');  

  const newSearchParams = new URLSearchParams();
  if (keyword) {
    newSearchParams.set('keyword', keyword);
  }

  const newUrl = `/records/?${newSearchParams.toString()}`;
  history.push(newUrl);
    setData({})
    setCount(0)
    setPopoverOpen(!popoverOpen);
  };

  const formatKey = (key) => {
    return key
      .split("_") // Split the string by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words with a space
  };

  const keyHandle=(key)=>{
    const searchParams = new URLSearchParams(location.search);

    // Check if 'keyword' parameter already exists
    if (searchParams.has('keyword')) {
      if (key === '') {
        searchParams.delete('keyword');
      } else {
        // Update existing keyword with the new value
        searchParams.set('keyword', key);
      }
    } else {
      // Append the new keyword if it doesn't exist
      searchParams.append('keyword', key);
    }
    setKeyword(key)
    const newUrl = `/records/?${searchParams.toString()}`;
    history.push(newUrl);
  }

  return (
    <>
    <Row>
    <Input
                                      placeholder="Search Records"
                                      value={keyword || ""}
                                      onChange={(e) =>
                                        keyHandle(e.target.value)
                                      }
                                      type="text"
                                    />
                                    </Row>
      <Row className="header-btn-lg">
        <Col md="12">
          <Nav className="header-megamenu">
            <NavItem>
              <NavLink onClick={togglePopover} id="PopoverMegaMenu">
                <i className="nav-link-icon pe-7s-search"> </i>
                {count > 0 ? <p style={{fontWeight:'600',color:'#1e90ff',marginBottom:'2px'}}>{count}&nbsp;</p> : '' }Filter By
                <FontAwesomeIcon
                  className="ms-2 opacity-5"
                  icon={faAngleDown}
                />
              </NavLink>
            </NavItem>
            <Popover
              className="rm-max-width"
              placement="bottom"
              fade={false}
              trigger="legacy"
              isOpen={popoverOpen}
              target="PopoverMegaMenu"
              toggle={togglePopover}
            >
              <div
                style={{ width: "1000px" }}
                className="dropdown-mega-menu p-0"
              >
                <div className="dropdown-menu-header">
                  <div className="dropdown-menu-header-inner bg-plum-plate">
                    <div
                      className="menu-header-image"
                      style={{
                        backgroundImage: "url(" + bg4 + ")",
                      }}
                    />
                    <div className="menu-header-content text-white">
                      <h5 className="menu-header-title">Filter Record</h5>
                    </div>
                  </div>
                </div>

                <TransitionGroup>
                  <CSSTransition
                    component="div"
                    classNames="TabsAnimation"
                    appear={true}
                    timeout={0}
                    enter={false}
                    exit={false}
                  >
                    <div>
                      <Row className="g-2 p-2">
                        <Col md="8">
                          <div id="accordion" className="">
                            <Card className="mt-1">
                              <CardHeader
                                className="b-radius-0"
                                id="headingTwo"
                              >
                                <Row className="w-100">
                                  <Col xs="10">
                                    <Button
                                      block
                                      color="link"
                                      className="text-start m-0 p-0"
                                      onClick={() => toggleAccordion(1)}
                                      aria-expanded={accordion[1]}
                                      aria-controls="collapseOne"
                                    >
                                      <h5 className="m-0 p-0">Owner Details</h5>
                                    </Button>
                                  </Col>
                                  <Col xs="2">
                                    <Button
                                      color="link"
                                      onClick={() => toggleAccordion(1)}
                                    >
                                      {accordion[1] ? "Collapse" : "Expand"}
                                    </Button>
                                  </Col>
                                </Row>
                              </CardHeader>
                              <Collapse
                                isOpen={accordion[1]}
                                data-parent="#accordion"
                                id="collapseTwo"
                              >
                                <CardBody>
                                  <FormGroup floating className="p-0">
                                    <Input
                                      placeholder="50700"
                                      value={data?.owner_full_name || ""}
                                      onChange={(e) => setData({...data, owner_full_name:e.target.value})}
                                      type="text"
                                    />
                                    <Label for="examplePassword">
                                      Owner Name
                                    </Label>
                                  </FormGroup>
                                  <FormGroup floating className="p-0">
                                    <Input
                                      placeholder="50700"
                                      value={data?.address || ""}
                                      onChange={(e) =>
                                        setData({...data, address:e.target.value})
                                      }
                                      type="text"
                                    />
                                    <Label for="examplePassword">Address</Label>
                                  </FormGroup>
                                </CardBody>
                              </Collapse>
                            </Card>
                            <Card className="mt-1">
                              <CardHeader id="headingOne">
                                <Row className="w-100">
                                  <Col xs="10">
                                    <Button
                                      block
                                      color="link"
                                      className="text-start m-0 p-0"
                                      onClick={() => toggleAccordion(0)}
                                      aria-expanded={accordion[0]}
                                      aria-controls="collapseOne"
                                    >
                                      <h5 className="m-0 p-0">
                                        Temperature Status
                                      </h5>
                                    </Button>
                                  </Col>
                                  <Col xs="2">
                                    <Button
                                      color="link"
                                      onClick={() => toggleAccordion(0)}
                                    >
                                      {accordion[0] ? "Collapse" : "Expand"}
                                    </Button>
                                  </Col>
                                </Row>
                              </CardHeader>
                              <Collapse
                                isOpen={accordion[0]}
                                data-parent="#accordion"
                                id="collapseOne"
                                aria-labelledby="headingOne"
                              >
                                <CardBody className="ms-2">
                                  <FormGroup className="p-0" check>
                                    <Input
                                    value={data?.temperature_status || ''}
                                      onChange={(e) => 
                                        setData({...data, temperature_status:e.target.value})}
                                      block
                                      type="select"
                                    >
                                      <option value="">None</option>
                                      <option value="cold">Cold</option>
                                      <option vlaue="warm">Warm</option>
                                      <option value="hot">Hot</option>
                                      <option value="under_contract">
                                        Under Contract
                                      </option>
                                    </Input>
                                  </FormGroup>
                                </CardBody>
                              </Collapse>
                            </Card>

                           
                          </div>
                        </Col>
                        <Col md="4">
                          <Card>
                            <CardBody>
                              <CardTitle>Added Filters</CardTitle>
                              {Object.entries(data).map(([key, value]) => (
                                value !== '' && (<Row key={key}>
                                  <Col xs="8">
                                    <p className="mb-1">
                                      <span className="fw-bolder">
                                        {formatKey(key)}:{" "}
                                      </span>
                                      {formatKey(value)}
                                    </p>
                                  </Col>
                                  <Col xs="4" className="text-end">
                                    <Button
                                      className="border-0 btn-transition"
                                      outline
                                      color="danger"
                                      title=" Delete"
                                      onClick={() => del(key)}
                                    >
                                      <FontAwesomeIcon
                                        icon={faTrashAlt}
                                        size="1x"
                                      />
                                    </Button>
                                  </Col>
                                </Row>)
                              ))}
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>

                      <Col
                        md="xs"
                        className="mt-2 mb-2 d-flex justify-content-center"
                      >
                        <Button
                          className="btn-wide btn-transition me-2"
                          color="secondary"
                          onClick={reset}
                        >
                          Reset Filters
                        </Button>
                        <Button
                          onClick={filter}
                          className=" btn-wide btn-transition"
                          color="primary"
                        >
                          Apply Filters
                        </Button>
                      </Col>
                    </div>
                  </CSSTransition>
                </TransitionGroup>
              </div>
            </Popover>
          </Nav>
        </Col>
      </Row>
    </>
  );
}
